import axios from "axios";
import { store } from "../store/store";
import { setAlert, setAuth } from "../store/action/action";
import config from "../config.json";

const API_LIVE = config.API_LIVE;
const api = axios.create({
  baseURL: API_LIVE,
});

api.interceptors.request.use(
  (config) => {
    const token = store.getState().auth?.token;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log(error, "error");
    if (error.response?.status === 401) {
      //   store.dispatch(logout());
      store.dispatch({ type: "LOGOUT" });
      store.dispatch(
        setAlert({
          open: true,
          variant: "success",
          message: "You have been successfully logged out.",
        }),
      );
      window.location.replace("/");
    }

    return Promise.reject(error);
  },
);

api.interceptors.response.use(
  (response) => {
    const refreshedToken = response.headers["x-refreshed-token"];

    if (refreshedToken) {
      console.log("New Token:", refreshedToken);

      store.dispatch(
        setAuth({
          ...store.getState().auth,
          token:refreshedToken,
        }),
      );
      
    }

    return response;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default api;
